import { PcbNodeTypes } from "@buildwithflux/models";
import { get } from "lodash";
import { Clipper } from "../../clipper/clipper";
import { nodeHasFillOnLayer } from "../../fills/FillHelpers";
import { filterTruthy } from "../../helpers/arrays";
import { PcbNodeHelper } from "../../nodes/pcbNodeHelper";
import { getTopLevelLayoutOfNode } from "../../nodes/traversal";
export function calcCopperFills(inputs) {
    const fillShapesByNetLayer = Object.fromEntries(filterTruthy(Object.values(inputs.pcbLayoutNodes).flatMap((fillNode) => {
        if (fillNode.type === PcbNodeTypes.fill && PcbNodeHelper.isVirtualNode(fillNode)) {
            const hostNodeUid = fillNode.virtualNodeInfo.originNodeUid;
            const layerShapes = inputs.shapesMap[hostNodeUid];
            if (!layerShapes)
                return null;
            // QUESTION: how can we avoid getting the layoutNode here
            // and just use the layerShapes data?
            const layoutNode = getTopLevelLayoutOfNode(inputs.pcbLayoutNodes, fillNode.uid);
            if (!layoutNode)
                return null;
            const hostNode = inputs.pcbLayoutNodes[hostNodeUid];
            if (!hostNode || (hostNode.type !== PcbNodeTypes.net && hostNode.type !== PcbNodeTypes.polygon)) {
                return null;
            }
            // To make typescript happy with the predicate
            const nodeHasFillOnLayerPredicate = (l) => nodeHasFillOnLayer(hostNode, l);
            const layers = Object.values(layoutNode.bakedRules.stackup ?? {}).filter(nodeHasFillOnLayerPredicate);
            return layers.map((layer) => {
                const polygons = get(layerShapes, [layoutNode.uid, layer.uid], []).filter((polygon) => !!polygon);
                const layerShape = Clipper.shape(polygons);
                return [`${hostNodeUid}:${layer.orientation ?? layer.name}`, layerShape];
            });
        }
        return null;
    })));
    return fillShapesByNetLayer;
}
//# sourceMappingURL=copperFills.js.map